var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"timestamp"},[(_vm.variant)?_c('b-badge',{attrs:{"variant":_vm.variant}},[_vm._v(_vm._s(_vm.formattedDate))]):[_vm._v(_vm._s(_vm.formattedDate))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }